import React from 'react';
import './Loading.scss';

export const LoadingIndicator = ({className, error}) => {
  return (
    <div className={'loading-container ' + (className || '')}>
      <img
        src={error ? '/error.png' : '/loading.gif'}
        alt={error ? 'Error icon' : 'Loading icon'}
      />
      {error ? <p>{error}</p> : null}
    </div>
  );
};
